import { useQuery } from "react-query";
import {
  getMyCancelledDemcoOrders,
  getMyDemcoOrders,
} from "../../actions/my-orders/services";
import MyOrdersTable from "./MyOrdersTable";

const columns = [
  "Reference",
  // "Product Name",
  "Collection Name",
  "Sent Date",
  "Progress",
  "Order Details",
];
const canceleldColumns = [
  "Product Name",
  "Order Reference",
  "Delete Date",
  "Actions",
];

export default function DemcoProductOrders({
  orderType,
  url,
  orderStatus,
  selectedDate,
}: {
  orderType: string;
  url: string;
  orderStatus: string;
  selectedDate: any;
}) {
  const { data, isLoading, isFetching, isError, refetch } = useQuery(
    ["my_demco_orders", orderStatus, selectedDate],
    orderStatus === "cancelled"
      ? () => getMyCancelledDemcoOrders(selectedDate)
      : () => getMyDemcoOrders(selectedDate),
    {
      keepPreviousData: true,
    }
  );

  if (isError) {
    return <p>Error!</p>;
  }

  return (
    <div>
      <MyOrdersTable
        columns={orderStatus === "cancelled" ? canceleldColumns : columns}
        isLoading={isLoading || isFetching}
        orderType={orderType}
        data={orderStatus === "cancelled" ? data?.data : data?.data.data}
        orderStatus={orderStatus}
        url={url}
        refetch={refetch}
      />
    </div>
  );
}
